// src/services/adminMembres.js
//
// Domaine Admin — Membres (façade Worker Admin → Worker Paiement)
// Routes utilisateurs / fiche / suspension / réactivation.

import { apiFetch, buildQuery } from './adminHttp';

/* ============================================================
 * LISTE DES MEMBRES / UTILISATEURS
 * GET /admin/utilisateurs
 * ============================================================ */
export async function getUtilisateurs(params = {}) {
  return apiFetch(`/admin/utilisateurs${buildQuery(params)}`, {
    method: 'GET',
  });
}

/* ============================================================
 * FICHE MEMBRE
 * POST /admin/membres/fiche
 * Body : { identifiantDsi }
 * ============================================================ */
export async function getMembreFiche(identifiantDsi) {
  return apiFetch('/admin/membres/fiche', {
    method: 'POST',
    body: JSON.stringify({ identifiantDsi }),
  });
}

/* ============================================================
 * SUSPENDRE
 * POST /admin/membres/suspendre
 * Body : { identifiantDsi, motif? }
 * ============================================================ */
export async function suspendreMembre(identifiantDsi, motif) {
  const body = { identifiantDsi };
  if (motif !== undefined && motif !== null && String(motif).trim() !== '') {
    body.motif = String(motif).trim();
  }
  return apiFetch('/admin/membres/suspendre', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

/* ============================================================
 * RÉACTIVER
 * POST /admin/membres/reactiver
 * Body : { identifiantDsi, motif? }
 * ============================================================ */
export async function reactiverMembre(identifiantDsi, motif) {
  const body = { identifiantDsi };
  if (motif !== undefined && motif !== null && String(motif).trim() !== '') {
    body.motif = String(motif).trim();
  }
  return apiFetch('/admin/membres/reactiver', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
